import { render, staticRenderFns } from "./inputs.vue?vue&type=template&id=70a3fff2&scoped=true"
import script from "./inputs.vue?vue&type=script&lang=js"
export * from "./inputs.vue?vue&type=script&lang=js"
import style0 from "./inputs.vue?vue&type=style&index=0&id=70a3fff2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3fff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a3fff2')) {
      api.createRecord('70a3fff2', component.options)
    } else {
      api.reload('70a3fff2', component.options)
    }
    module.hot.accept("./inputs.vue?vue&type=template&id=70a3fff2&scoped=true", function () {
      api.rerender('70a3fff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fin-form/inputs.vue"
export default component.exports